function compact(seconds) {
  if (seconds < 60) return `${seconds}s`
  const minutes = Math.floor(seconds / 60)
  const remainder = seconds % 60
  return remainder ? `${minutes}m ${remainder}s` : `${minutes}m`
}

export function clientRunDurationLabel(startedAt, completedAt) {
  if (!startedAt || !completedAt || completedAt <= startedAt) return null
  const elapsedMs = completedAt - startedAt
  if (elapsedMs < 1000) return null
  return `Worked for ${compact(Math.round(elapsedMs / 1000))}`
}
